export default "__VITE_ASSET__IY_iiKg$__"